import React from 'react';
import { useEffect } from 'react';
import FilterChips from '../filters/FilterChipsEvents';

import useStore from '../../store/useStore';
import {
  Grid,
  FormControl,
  InputLabel,
  MenuItem,
  ButtonGroup,
  Button,
} from '@mui/material';

import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFilter,
  faList,
  faBorderAll,
} from '@fortawesome/free-solid-svg-icons';
import { ChevronDown } from '@carbon/icons-react';
import ButtonComponent from '../button';
import { HiOutlineViewGrid } from 'react-icons/hi';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { List, Calendar } from '@carbon/icons-react';

import { useNavigate } from "react-router-dom";




const clickMe = () => {
  console.log("Button Clicked!");
};

const FilterBarEvents = () => {

  //const navigate = useNavigate();
  const {

    setParams,

    //view /*filters, view, settings*/
  } = useStore((state: any) => ({

    setParams: state.setParams,

  }));


  const navigateDailySessions = () => {
    console.log("Navigate to daily sessions ");

    setParams('type', 'sessions');
    setParams('activeRoute', 'sessions');

    setFilter('MySessions', 0);


    //navigate("/sessions/daily");
  };


  const {
    view,
    filters,
    sectorsevents,
    types,
    groups,
    sectorgroups,
    formats,
    datasetType,
    changeDataSet,
    settings: {
      params: { displayviewswitch },
    },
    changeView,
    setFilter,
  } = useStore((state: any) => ({

    view: state.settings.params.view,
    filters: state.filters,
    sectorsevents: state.sectorsevents,
    types: state.types,
    groups: state.groups,
    sectorgroups: state.sectorgroups,
    formats: state.formats,
    datasetType: state.datasetType,
    settings: state.settings,
    changeView: state.changeView,
    changeDataSet: state.changeDataSet,
    setFilter: state.setFilter,
  }));

  const { cards } = useStore((state: any) => ({ cards: state.MUIdataEvents.rows }));


  const [selectedSector, setSelectedSector] = React.useState<string[]>([]);
  const [selectedType, setSelectedType] = React.useState<string[]>([]);
  const [selectedGroup, setSelectedGroup] = React.useState<string[]>([]);
  const [selectedFormat, setSelectedFormat] = React.useState<string[]>([]);
  const [selectedSectorGroup, setSelectedSectorGroup] = React.useState<string[]>([]);

  const handleChangeSector = (event: any) => {
    const {
      target: { value }
    } = event;

    let valueSelect = (typeof value === "string" ? value.split(",") : value);
    //set selected sector value
    setSelectedSector(valueSelect);

    //console.log(valueSelect);
    //set filter value and rebuild data
    setFilter('SectorEvent', valueSelect);
  };

  const handleChangeType = (event: any) => {
    const {
      target: { value }
    } = event;

    let valueSelect = (typeof value === "string" ? value.split(",") : value);
    //set selected type value
    setSelectedType(valueSelect);

    //set filter value and rebuild data
    setFilter('Types', valueSelect);
  };

  const handleChangeGroup = (event: any) => {
    const {
      target: { value }
    } = event;

    let valueSelect = (typeof value === "string" ? value.split(",") : value);
    //set selected group value
    setSelectedGroup(valueSelect);

    //set filter value and rebuild data
    setFilter('Groups', valueSelect);
  };

  const handleChangeSectorGroup = (event: any) => {
    const {
      target: { value }
    } = event;

    let valueSelect = (typeof value === "string" ? value.split(",") : value);

    console.log(valueSelect);

    //set selected group value
    setSelectedSectorGroup(valueSelect);

    //set filter value and rebuild data
    setFilter('SectorGroups', valueSelect);
  };

  const handleChangeFormat = (event: any) => {
    const {
      target: { value }
    } = event;

    let valueSelect = (typeof value === "string" ? value.split(",") : value);
    //set selected format value
    setSelectedFormat(valueSelect);

    //set filter value and rebuild data
    setFilter('Formats', valueSelect);
  };

  //watch changes to filter.SectorSession (useful when resetting value by filterchips)
  useEffect(() => {
    // watch change on filter sector
    //console.log(filters.SectorSession)
    if (filters.SectorEvent == '')
      setSelectedSector([]); //reset select box value to empty array
    if (filters.Types == '')
      setSelectedType([]); //reset select box value to empty array
    if (filters.Groups == '')
      setSelectedGroup([]); //reset select box value to empty array
    if (filters.Formats == '')
      setSelectedFormat([]); //reset select box value to empty array
    if (filters.SectorGroups == '')
      setSelectedSectorGroup([]); //reset select box value to empty array
  }, [filters.SectorEvent, filters.Types, filters.Groups, filters.Formats, filters.SectorGroups])


  const setView = (
    newView: string,
  ) => {
    if (newView !== null) {
      changeView(newView);
    }
  };
  return (
    <>
      <div id='FilterBarEvents' style={{  display: 'none',cursor:'pointer',width: '100%', padding: '0 0 1.5rem 0', backgroundColor: "#293336", margin: "0px", paddingRight: "10px" }}>
        <div className='ituContainer grid'>

          {/* Sector filter */}
          <div data-span="3" >
            <FormControl variant="filled" id="filterApp" fullWidth>
              <InputLabel id="sector-filter-label"
                style={{ color: '#fff' }}
                disableAnimation={true}
                shrink={false}
              >
                By Sector
              </InputLabel>
              <Select
                inputProps={{ MenuProps: { MenuListProps: { sx: { backgroundColor: '#182124', color: '#fff' } } } }}
                IconComponent={ChevronDown}
                variant="filled"
                style={{ color: '#fff' }}
                id="sector-events-filter"
                labelId="sector-events-filter-select-label"
                multiple
                value={selectedSector}
                //disabled={filters.SectorSession.length > 0}
                onChange={handleChangeSector}
                renderValue={() => ""}
              >
                {sectorsevents.map((sectorItem: any) => (
                  <MenuItem key={sectorItem} value={sectorItem}>
                    <Checkbox checked={selectedSector.indexOf(sectorItem) > -1} />
                    <ListItemText primary={sectorItem} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>

          {/* Types filter */}
          <div data-span="3">
            <FormControl variant="filled" id="filterApp" fullWidth>
              <InputLabel id="types-filter-label"
                style={{ color: '#fff' }}
                disableAnimation={true}
                shrink={false}
              >
                By Type
              </InputLabel>
              <Select
                inputProps={{ MenuProps: { MenuListProps: { sx: { backgroundColor: '#182124', color: '#fff' } } } }}
                IconComponent={ChevronDown}
                variant="filled"
                style={{ color: '#fff' }}
                id="types-events-filter"
                labelId="types-events-filter-select-label"
                multiple
                value={selectedType}
                //disabled={filters.SectorSession.length > 0}
                onChange={handleChangeType}
                renderValue={() => ""}
              >
                {types.map((item: any) => (
                  <MenuItem key={item} value={item}>
                    <Checkbox checked={selectedType.indexOf(item) > -1} />
                    <ListItemText primary={item} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>

          {/* Sector Groups filter */}
          <div data-span="3">
            <FormControl variant="filled" id="filterApp" fullWidth>
              <InputLabel id="sectorgroups-filter-label"
                style={{ color: '#fff' }}
                disableAnimation={true}
                shrink={false}
              >
                By Group
              </InputLabel>
              <Select
                inputProps={{ MenuProps: { MenuListProps: { sx: { backgroundColor: '#182124', color: '#fff' } } } }}
                IconComponent={ChevronDown}
                variant="filled"
                style={{ color: '#fff' }}
                id="sectorgroups-events-filter"
                labelId="sectorgroups-events-filter-select-label"
                multiple
                value={selectedSectorGroup}
                onChange={handleChangeSectorGroup}
                renderValue={() => ""}
              >
                {sectorgroups.map((item: any) => (
                  <MenuItem key={item} value={item}>
                    <Checkbox checked={selectedSectorGroup.indexOf(item) > -1} />
                    <ListItemText primary={item} style={{ width: 'fit-content' }} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>

          {/* Formats filter */}
          <div data-span="3">
            <FormControl variant="filled" id="filterApp" fullWidth>
              <InputLabel id="formats-filter-label"
                style={{ color: '#fff' }}
                disableAnimation={true}
                shrink={false}
              >
                By Format
              </InputLabel>
              <Select
                inputProps={{ MenuProps: { MenuListProps: { sx: { backgroundColor: '#182124', color: '#fff' } } } }}
                IconComponent={ChevronDown}
                variant="filled"
                style={{ color: '#fff' }}
                id="formats-events-filter"
                labelId="formats-events-filter-select-label"
                multiple
                value={selectedFormat}
                onChange={handleChangeFormat}
                renderValue={() => ""}
              >
                {formats.map((item: any) => (
                  <MenuItem key={item} value={item}>
                    <Checkbox checked={selectedFormat.indexOf(item) > -1} />
                    <ListItemText primary={item} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        </div>
      </div>


      <div className='ituContainer '>
        <p id='numberOfResult'><strong>{cards.length}</strong> Events found</p>
      </div>


      {/* display filter chips component only if filters values are not null */}
      {
        filters.searchEvent.length > 0 ||
          filters.SectorEvent.length > 0 ||
          filters.Types.length > 0 ||
          filters.Groups.length > 0 ||
          filters.SectorGroups.length > 0 ||
          filters.Formats.length > 0
          ? (
            <FilterChips />
          ) : null
      }


      <div style={{ width: '100%', padding: '1rem 0 1.5rem 0', margin: "0px", paddingRight: "10px" }}>
        <div className='ituContainer' style={{ display: "flex", justifyContent: "space-between" }}>
          <ButtonComponent title="Daily sessions" onClick={navigateDailySessions} />
          <div>

            <ToggleButtonGroup
              id='togglebuttonmobile'
              color="primary"
              value={view}
              exclusive
              aria-label="View"
            >
              <ToggleButton value="card" aria-label="card" disableRipple disableFocusRipple disableTouchRipple onClick={(e) => setView('card')}>
                <HiOutlineViewGrid size="20" />&nbsp;Card view
              </ToggleButton>
              <ToggleButton value="list" aria-label="list" disableRipple disableFocusRipple disableTouchRipple onClick={(e) => setView('list')}>
                <List size="20" />&nbsp;List view
              </ToggleButton>
              <ToggleButton value="calendar" aria-label="calendar" disableRipple disableFocusRipple disableTouchRipple onClick={(e) => setView('calendar')}>
                <Calendar size="20" />&nbsp;Calendar view
              </ToggleButton>

            </ToggleButtonGroup>

          </div>
        </div>
      </div>
    </>
  );
};

export default FilterBarEvents;
